import React from 'react';
// From https://github.com/oliviertassinari/react-swipeable-views
import SwipeableViews from 'react-swipeable-views';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import {Tabs, Tab} from 'material-ui/Tabs';

import styles from './styles/DetailsPageStyles';

import MainData from 'components/detailsPage/MainData';
import PDOFData from 'components/detailsPage/PDOFData';
import BOMData from 'components/detailsPage/BOMData';
import MapData from 'components/detailsPage/MapData';
import ChartsData from 'components/detailsPage/ChartsData';
import VideoData from 'components/detailsPage/VideoData';

import { getIcn, getIcnPlus, getIcnSpeed, getIcnAcceleration, getBomList } from 'actions/icnActions';
import { getDeviceByType, getAccountById } from 'actions/entityServicesActions';
import { getTimeZone } from 'actions/googleServicesActions';
import { getPdof, getPredictiveImage } from 'actions/crashboxxServicesActions';
import moment from 'moment';

class DetailsPage extends React.Component {
    constructor(props){
        super(props);

        /*
            la pagina chiamante passerà l' id come property
        */
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            slideIndex: 0
        };
    }

    /**
     * check su id e richieste web api
    */
    componentDidMount(){
        this.props.getIcn(this.props.id);
        if(this.props.isIcnPlus || this.props.isDent)
        {
            this.props.getIcnPlus(this.props.id, this.props.isDent);
            this.props.getIcnAcceleration(this.props.id);
            this.props.getIcnSpeed(this.props.id);
            this.props.getBomList(this.props.id);
        }
    }

    /**
     * chiamato quando le chiamate web api rispondono
     * @param {*} newProps
     */
    componentWillReceiveProps(newProps) {

        if(newProps.isIcnLoading !== this.props.isIcnLoading && newProps.icn)
        {
            /*
                se è arrivato l'icn allora posso lanciare il dispatch per il caricamento del device - account - google ...
            */
            this.props.getDeviceByType(newProps.icn.deviceId, newProps.icn.deviceIdType);
            this.props.getAccountById(newProps.icn.accountId);
            var momentutc = moment.utc(newProps.icn.crashDate);
            var timeStamp = momentutc.unix();
            this.props.getTimeZone(newProps.icn.latitude, newProps.icn.longitude, timeStamp, this.props.currentLanguage)
            this.props.getPdof(newProps.icn.pdof);
        }
    }

    /**
     * gestione cambio tab
     */
    handleChange = (value) => {
        this.setState({
          slideIndex: value,
        });
      };


    render() {
        console.info("details page rendered");
        var { translate, isIcnPlus, isDent} = this.props;

        var showPlayer = this.props.id === "17436762" && (isIcnPlus || isDent);

        return (
            <div>
                <Tabs
                    inkBarStyle={styles.inkBarStyle}
                    style={styles.tabsHeader}
                    onChange={this.handleChange}
                    value={this.state.slideIndex}
                    >
                    <Tab style={styles.tabHeader} label={translate('DetailsPage.mainDataTitle')} value={0} />
                    <Tab style={styles.tabHeader} label={translate('DetailsPage.mapTitle')} value={1} />
                    {
                        showPlayer ?
                            <Tab style={styles.tabHeader} label={"Dash cam Video"} value={5} />
                        : null
                    }
                    {
                        isIcnPlus ?
                            <Tab style={styles.tabHeader} label={translate('DetailsPage.chartsTitle')} value={2} />
                        : null
                    }
                    {
                        isIcnPlus ?
                        <Tab style={styles.tabHeader} label={translate('DetailsPage.pdofTitle')} value={3} />
                        : null
                    }
                    {
                        isDent ?
                        <Tab style={styles.tabHeader} label={translate('DetailsPage.repairCostTitle')} value={4} />
                        : null
                    }

                </Tabs>
                <SwipeableViews
                    index={this.state.slideIndex}
                    onChangeIndex={this.handleChange}
                    >
                    <div>
                        <MainData />
                    </div>
                    <div style={styles.slide}>
                        <MapData isIcnPlus={isIcnPlus} isDent={isDent} />
                    </div>

                    <div style={styles.slide}>
                        <ChartsData />
                    </div>
                    <div style={styles.slide}>
                        <PDOFData />
                    </div>
                    <div style={styles.slide}>
                        <BOMData />
                    </div>
                    <div style={styles.slide}>
                        <VideoData />
                    </div>
                </SwipeableViews>
            </div>
        );
    }
}

DetailsPage.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){

    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        icn: state.icnSearch.item,
        isIcnLoading: state.icnSearch.isSearching,
    }
}
export default connect(mapStateToProps, {getIcn, getIcnPlus, getIcnSpeed, getIcnAcceleration, getBomList,
    getDeviceByType, getAccountById, getTimeZone, getPdof, getPredictiveImage})(DetailsPage);


// WEBPACK FOOTER //
// ./src/containers/detailsPage/DetailsPage.js